




















import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { IMaskComponent } from 'vue-imask'
import { debounce } from '@/utils/helpers/helpFunctions'

interface Data {}

interface Methods {
  onEnter: () => void
  onChange: (value: any) => void
  onInput: (value: any) => void
}

interface Computed {}

interface Props {
  mask: object
  debounceWait: number
}

export default Vue.extend({
  name: 'UiInput',
  components: {
    MaskedInput: IMaskComponent
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    mask: {
      type: [Object, Boolean],
      default: () => false
    },
    debounceWait: {
      type: Number,
      default: () => 0
    },
    error: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    onEnter (): void {
      this.$emit('onEnter')
    },
    onChange (value: any): void {
      this.$emit('change', value)
    },
    onInput (value: any): void {
      if (this.debounceWait > 0) {
        debounce(() => {
          this.$emit('input', value)
        }, this.debounceWait)
        return
      }
      this.$emit('input', value)
    },
    onFocus (): void {
      this.$emit('focus')
    },
    onBlur (): void {
      this.$emit('blur')
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
